const routes = [
  {
    path: '/casos',
    name: 'casos',
    component: () => import('@/views/Casos/Casos')
  }, {
    path: '/casos/supervisar',
    name: 'casos.supervisar',
    component: () => import('@/views/Casos/Supervisar')
  }, {
    path: '/casos/buscar',
    name: 'casos.buscar',
    component: () => import('@/views/Casos/Buscar')
  }, {
    path: '/casos/cerrados',
    name: 'casos.cerrados',
    component: () => import('@/views/Casos/Cerrados')
  }, {
    path: '/notificaciones',
    name: 'casos.notificaciones',
    component: () => import('@/views/Casos/Notificaciones')
  }, {
    path: '/notificacionesNotes',
    name: 'casos.notificacionesNotes',
    component: () => import('@/views/Casos/NotificacionesNotes')
  }, {
    path: '/casos/nuevo',
    name: 'casos.nuevo',
    component: () => import('@/views/Casos/Guardar')
  }, {
    path: '/casos/editar/:id',
    name: 'casos.editar',
    component: () => import('@/views/Casos/Guardar')
  }, {
    path: '/casos/espera',
    name: 'casos.espera',
    component: () => import('@/views/Casos/Espera')
  }, {
    path: '/casos/historico',
    name: 'casos.historico',
    component: () => import('@/views/Casos/Historico')
  }, {
    path: '/casos/geolocalizacion',
    name: 'casos.geolocalizacion',
    component: () => import('@/views/Casos/Geolocalizacion')
  }, {
    path: '/casos/tabguardar',
    name: 'casos.tabguardar',
    component: () => import('@/views/Casos/TabGuardar')
  }, {
    path: '/casos/tabcasos',
    name: 'casos.tabcasos',
    component: () => import('@/views/Casos/TabCasos')
  },
  {
    path: '/casos/supervisarHistorico',
    name: 'casos.supervisarHistorico',
    component: () => import('@/views/Casos/SupervisarHistorico')
  },
  {
    path: '/casos/sinasignar',
    name: 'casos.sinAsignar',
    component: () => import('@/views/Casos/CasosSinAsignar')
  },
  {
    path: '/casos/miscasoscreados',
    name: 'casos.creados',
    component: () => import('@/views/Casos/MisCasosCreados')
  },
  {
    path: '/casos/supervisarProcesos',
    name: 'casos.supervisarProcesos',
    component: () => import('@/views/Casos/SupervisionProcesos')
  },
  {
    path: '/casos/supervisarHistoricoProcesos',
    name: 'casos.supervisarHistoricoProcesos',
    component: () => import('@/views/Casos/SupervisionProcesosHistorico')
  },
  {
    path: '/casos/supervisarEquipo',
    name: 'casos.supervisarEquipo',
    component: () => import('@/views/Casos/SupervisionMiEquipo')
  },
  {
    path: '/casos/supervisarEquipoHistorico',
    name: 'casos.supervisarEquipoHistorico',
    component: () => import('@/views/Casos/SupervisionMiEquipoHistorico')
  }


]

export default routes
